import { useLayoutEffect } from 'react';
import useAppErrorDispatcher from './useAppErrorDispatcher';

export type Origin =
  | {
      type: 'storeId';
      storeId: string;
    }
  | {
      type: 'socialMedia';
      source: string;
    }
  | null;

const useConfigurationErrorHandler = (
  country: string | null,
  origin: Origin
): void => {
  const { dispatch, reset } = useAppErrorDispatcher();

  const noConfig =
    origin === null ||
    country === null ||
    country === '' ||
    (origin.type === 'storeId' && origin.storeId === '') ||
    (origin.type === 'socialMedia' && origin.source === '');

  useLayoutEffect(() => {
    if (noConfig) {
      dispatch('storeIdOrCountryMissing');
    } else {
      reset('storeIdOrCountryMissing');
    }
  }, [noConfig, dispatch, reset]);
};

export default useConfigurationErrorHandler;
